import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from '@chakra-ui/react'
import { shortcuts } from 'enums/shortcuts'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import { shortcutCreator } from 'state/index'
import { State } from 'state/reducers'

interface Props {
    isOpen: boolean
    onClose: () => void
}

const ShortcutModal = ({ isOpen, onClose }: Props) => {
    const shortcutsList = useSelector(({ shortcuts }: State) => shortcuts)

    const dispatch = useDispatch()
    const { addShortcut } = bindActionCreators(shortcutCreator, dispatch)

    const [value, setValue] = useState<string>("")

    const onSubmit = () => {
        addShortcut(value)
        onClose()
        setValue("");
    }

    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Adicionar novo atalho</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Select placeholder="Selecione uma opção..." value={value} onChange={({ target }) => setValue(target.value)}>
                        {
                            shortcuts.map(stc => 
                                <option 
                                    key={stc.id} 
                                    value={stc.id}
                                    disabled={shortcutsList.find(st => st === stc.id) ? true : false}
                                >
                                    {stc.label}
                                </option>
                            )
                        }
                    </Select>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button variant="ghost" onClick={onClose}>Cancelar</Button>
                        <Button colorScheme="green" onClick={onSubmit}>Adicionar</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ShortcutModal